window.a4yStickyAtcInit = function () {
  if (window.a4yStickyAtcCleanup) {
    window.a4yStickyAtcCleanup();
  }

  var bar = document.getElementById('sticky-atc');
  var stickyBtn = document.getElementById('sticky-atc-btn');

  if (!bar || !stickyBtn) return;

  var formId = stickyBtn.getAttribute('data-product-form-id');
  var mainForm = document.getElementById(formId);
  var mainBtn =
    (mainForm && mainForm.querySelector('.product-form__submit')) ||
    document.querySelector('#' + formId + ' .product-form__submit') ||
    document.querySelector('.product-form__submit');

  if (!mainBtn) return;

  var mobileMediaQuery = window.matchMedia('(max-width: 749px)');
  var stickyHeader = document.querySelector('sticky-header');
  var productRoot = mainBtn.closest('.product');
  var mediaWrapper = productRoot && productRoot.querySelector('.product__media-wrapper');
  var visualViewport = window.visualViewport;
  var isVisible = false;
  var rafId = null;
  var abortController = new AbortController();
  var eventOptions = { passive: true, signal: abortController.signal };

  function setVisible(visible) {
    if (isVisible === visible) return;

    isVisible = visible;
    bar.classList.toggle('sticky-atc--visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function getTopOffset() {
    if (!stickyHeader) return 12;

    var headerRect = stickyHeader.getBoundingClientRect();
    var headerHeight = headerRect.bottom > 0 ? headerRect.height : 0;

    return headerHeight + 12;
  }

  function syncButtonLabel() {
    var mainBtnLabel = mainBtn.querySelector('span');
    if (!mainBtnLabel) return;

    var text = mainBtnLabel.textContent.trim();
    if (text) {
      stickyBtn.textContent = text;
    }
  }

  function syncViewportOffset() {
    var bottomOffset = 0;

    if (visualViewport) {
      bottomOffset = Math.max(0, window.innerHeight - visualViewport.height - visualViewport.offsetTop);
    }

    bar.style.setProperty('--sticky-atc-bottom-offset', bottomOffset + 'px');
  }

  function shouldShowBar() {
    if (!mobileMediaQuery.matches) return false;

    var topOffset = getTopOffset();
    var showBoundary = Math.max(topOffset - 12, 0);
    var hideBoundary = topOffset + 44;
    var mainBtnRect = mainBtn.getBoundingClientRect();
    var mainButtonPastViewport = mainBtnRect.bottom <= showBoundary;

    if (isVisible) {
      return mainBtnRect.top < hideBoundary;
    }

    if (!mainButtonPastViewport) return false;
    if (!mediaWrapper) return true;

    var mediaRect = mediaWrapper.getBoundingClientRect();
    var mediaPastViewport = mediaRect.bottom <= showBoundary;

    return mediaPastViewport;
  }

  function updateBarState() {
    rafId = null;
    syncViewportOffset();
    syncButtonLabel();
    setVisible(shouldShowBar());
  }

  function requestUpdate() {
    if (rafId !== null) return;

    rafId = window.requestAnimationFrame(updateBarState);
  }

  stickyBtn.addEventListener('click', function () {
    var mainBtnDisabled = mainBtn.hasAttribute('disabled') || mainBtn.getAttribute('aria-disabled') === 'true';

    if (mainBtnDisabled) {
      var variantPicker = document.querySelector('variant-selects, variant-radios');

      if (variantPicker) {
        variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      return;
    }

    mainBtn.click();
  }, { signal: abortController.signal });

  window.addEventListener('scroll', requestUpdate, eventOptions);
  window.addEventListener('resize', requestUpdate, { signal: abortController.signal });

  if (typeof mobileMediaQuery.addEventListener === 'function') {
    mobileMediaQuery.addEventListener('change', requestUpdate, { signal: abortController.signal });
  } else if (typeof mobileMediaQuery.addListener === 'function') {
    mobileMediaQuery.addListener(requestUpdate);
  }

  var buttonObserver = new MutationObserver(requestUpdate);
  buttonObserver.observe(mainBtn, {
    attributes: true,
    childList: true,
    subtree: true
  });

  if (visualViewport) {
    visualViewport.addEventListener('resize', requestUpdate, { signal: abortController.signal });
    visualViewport.addEventListener('scroll', requestUpdate, eventOptions);
  }

  window.a4yStickyAtcCleanup = function () {
    if (rafId !== null) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }

    abortController.abort();
    buttonObserver.disconnect();

    if (typeof mobileMediaQuery.removeListener === 'function') {
      mobileMediaQuery.removeListener(requestUpdate);
    }
  };

  requestUpdate();
};

window.a4yStickyAtcInit();
